import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "react-bootstrap";
import { TablePlaceholder } from "shared/ui/placeholders";
import { formatCurrency } from "shared/lib/format";
import { TABLE_COLUMN_WIDTHS } from "shared/lib/tableColumnWidths";
import ImageWithLoader from "shared/ui/image";
import CustomLoader from "shared/ui/loader";

const styles = {
  table: {
    className: "table table-centered mb-0",
  },
  thCenter: (width) => ({
    textAlign: "center",
    width: width,
  }),
  tdCenter: (width) => ({
    textAlign: "center",
    width: width,
  }),
  actionButton: {
    background: "none",
    border: "none",
    padding: 0,
  },
  loaderWrapper: {
    textAlign: "center",
    padding: "0.5rem",
  },
  endMessage: {
    textAlign: "center",
    color: "#6c757d", // bootstrap text-muted
    marginTop: "2rem",
    fontSize: 13,
  },
};

export default function ProductTable({
  items,
  loading,
  loadingMore,
  hasMore,
  loadMoreError,
  onEndReached,
  onRetryMore,
  loadingProductId,
  handleVisible,
  onEdit,
  onDelete,
}) {
  const COLUMN_WIDTHS = TABLE_COLUMN_WIDTHS.editTalbe;

  // ⚠️ `react-infinite-scroll-component` нь `next()` дуудмагц дотроо
  //    `actionTriggered = true` болгодог ба түүнийг ЗӨВХӨН `dataLength`
  //    өөрчлөгдөхөд reset хийдэг (dist/index.js:375-378). Тиймээс хүсэлт
  //    амжилтгүй болвол спиннер мөнхөд эргэлдэж, жагсаалт үхдэг байв.
  //    Алдаа гармагц `hasMore`-ыг хааж, доорх «Дахин оролдох» товчоор гаргана.
  const autoMore = hasMore && !loadMoreError;

  return (
    <div className="table-responsive-sm">
      <InfiniteScroll
        dataLength={items?.length || 0}
        next={onEndReached}
        hasMore={autoMore}
        scrollThreshold={0.9}
        loader={
          loadingMore ? (
            <div style={styles.loaderWrapper}>
              <CustomLoader fontSize={32} />
            </div>
          ) : null
        }
        endMessage={
          !hasMore &&
          !loadMoreError && (
            <p style={styles.endMessage}>Төгсгөлд нь хүрсэн байна</p>
          )
        }
      >
        <table className={styles.table.className}>
          <thead>
            <tr>
              <th style={styles.thCenter(COLUMN_WIDTHS.active)}>Идэвхтэй</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.image)}>Зураг</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.name)}>Нэр</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.price)}>Үнэ</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.stock)}>Үлдэгдэл</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.edit)}>Засах</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.delete)}>Устгах</th>
            </tr>
          </thead>
          <tbody>
            {loading && items.length === 0 ? (
              <TablePlaceholder rows={12} count={7} />
            ) : (
              items?.map((item) => {
                const isUpdating = loadingProductId === item.id;

                return (
                  <tr key={item.id}>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.active)}>
                      {isUpdating ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                          className="ms-3"
                        />
                      ) : (
                        <div>
                          <input
                            type="checkbox"
                            id={`switch_${item.id}`}
                            checked={item.isVisible}
                            data-switch="danger"
                            onChange={(e) => handleVisible(e, item.id)}
                          />
                          <label
                            htmlFor={`switch_${item.id}`}
                            data-on-label="On"
                            data-off-label="Off"
                          />
                        </div>
                      )}
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.image)}>
                      <ImageWithLoader
                        src={item.image}
                        alt={item.name}
                        width="40px"
                        height="40px"
                        className="avatar-sm"
                      />
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.name)}>
                      {item.name}
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.price)}>
                      {formatCurrency(item.price)}
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.stock)}>
                      {item.quantity}
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.edit)}>
                      <button
                        className="action-icon"
                        onClick={() => onEdit(item)}
                        style={styles.actionButton}
                      >
                        <i className="mdi mdi-square-edit-outline" />
                      </button>
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.delete)}>
                      <button
                        className="action-icon text-danger"
                        onClick={() => onDelete(item)}
                        style={styles.actionButton}
                      >
                        <i className="mdi mdi-delete-outline" />
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>

        {/* Автомат гүйлгэлт ажиллаагүй ч хэрэглэгч ХЭЗЭЭ Ч гацахгүй байх
            баталгаа — алдаа гарсан, эсвэл спиннер зогссон үед гараар үргэлжилнэ. */}
        {loadMoreError ? (
          <div className="text-center py-3">
            <p className="mb-2 text-danger" style={{ fontSize: 13 }}>
              Цааш татахад алдаа гарлаа.
            </p>
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={onRetryMore}
            >
              Дахин оролдох
            </button>
          </div>
        ) : hasMore && !loadingMore ? (
          <div className="text-center py-3">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={onEndReached}
            >
              Цааш үзэх
            </button>
          </div>
        ) : null}
      </InfiniteScroll>
    </div>
  );
}
